/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";

class InvoiceemployeeItem extends Component {
    rowClassName = "";

    state = {
        showingTabletDetail: false,
    };

    toggleTabletDetail = () => {
        let showing = this.state.showingTabletDetail;
        this.setState({ showingTabletDetail: !showing });
    };

    renderDate = (dateString) => {
        let d = new Date(dateString);
        return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
    };
    renderTabletModeDetail = (inv) => {

        if (!this.state.showingTabletDetail) return null;

        return (
            <tr className="child">
                <td className="child" colspan="2">
                    <table>
                        <tr data-dt-row="0" data-dt-column="1">
                            <td>
                                <div className="tableTitle"><Trans desc="Eğitim Alan">10116</Trans></div>
                            </td>
                            <td>{inv.employee.name}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="2">
                            <td>
                                <div className="tableTitle"><Trans desc="Başlangıç">10117</Trans></div>
                            </td>
                            <td>{this.renderDate(inv.startDate)}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="3">
                            <td>
                                <div className="tableTitle"><Trans desc="Bitiş">10118</Trans></div>
                            </td>
                            <td>{this.renderDate(inv.endDate)}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="4">
                            <td>
                                <div className="tableTitle"><Trans desc="Grup">10119</Trans></div>
                            </td>
                            <td>{inv.group ? inv.group.label : null}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="5">
                            <td>
                                <div className="tableTitle"><Trans desc="Katılım">10522</Trans></div>
                            </td>
                            <td>{inv.attendanceOutcome ? i18next.t("10523") : i18next.t("10524")}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="6">
                            <td>
                                <div className="tableTitle"><Trans desc="Başarı">10120</Trans></div>
                            </td>
                            <td>
                                {inv.successful ? (
                                    <div className="durumBasarili"><Trans desc="Başarılı">10525</Trans></div>
                                ) : (
                                    <div className="durumBasarisiz"><Trans desc="Başarısız">10526</Trans></div>
                                )}
                            </td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="7">
                            <td>
                                <div className="tableTitle"><Trans desc="Gün">10121</Trans></div>
                            </td>
                            <td>{inv.duration}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="8">
                            <td>
                                <div className="tableTitle"><Trans desc="Günlük">10122</Trans></div>
                            </td>
                            <td>{inv.pricePerDay}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="9">
                            <td>
                                <div className="tableTitle"><Trans desc="Toplam">10123</Trans></div>
                            </td>
                            <td>{parseInt(inv.pricePerUnit)}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        );
    };

    render() {
        const { inv } = this.props;
        // console.log("inv item:");
        // console.log(inv); 
        return (
            <>
                <DesktopBreakpoint>
                    <tr className={this.rowClassName}>
                        <td className="showGrup">{this.renderDate(inv.date)}</td>
                        <td className="showGrup">{inv.company ? inv.company.name : null}</td>
                        <td className="showGrup">{inv.position ? inv.position.name : null}</td>
                        <td className="showGrup">{inv.employee ? inv.employee.name : null}</td>
                        <td className="showGrup">{inv.documentType}</td>
                        <td className="showGrup">{inv.foPrice}</td>
                        {/* <td className="showGrup">
                            <span className="icon-icon-training-web"></span>
                        </td> */}
                        {/* <td className="showGrup">{inv.employee.name}</td>
                        <td className="showGrup">{this.renderDate(inv.startDate)}</td>
                        <td className="showGrup">{this.renderDate(inv.endDate)}</td>
                        <td className="showGrup">{inv.group ? inv.group.label : null}</td>
                        <td className="showGrup">{inv.attendanceOutcome ? i18next.t("10523") : i18next.t("10524")}</td>
                        <td className="showGrup">
                            {inv.successful ? (
                                <div className="durumBasarili"><Trans desc="Başarılı">10525</Trans></div>
                            ) : (
                                <div className="durumBasarisiz"><Trans desc="Başarısız">10526</Trans></div>
                            )}
                        </td>
                        <td className="showGrup">{inv.duration}</td>
                        <td className="showGrup">{inv.pricePerDay}</td>
                        <td className="showGrup">
                            {parseInt(inv.pricePerUnit)}
                        </td> */}
                    </tr>
                </DesktopBreakpoint>
                <TabletBreakpoint>
                    <tr className={this.rowClassName} onClick={this.toggleTabletDetail}>
                        <td className="showGrup">
                            <span className="icon-icon-training-web"></span>
                        </td>
                        {/* <td className="showGrup">{inv.training.name}</td> */}
                        <td className="showGrup">{inv.employee ? inv.employee.name : null}</td>

                    </tr>
                    {/* {this.renderTabletModeDetail(inv)} */}
                </TabletBreakpoint>
            </>
        );
    }
}

export default InvoiceemployeeItem;
